import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { F as FilterDropdown } from './FilterDropdown-BDvi3pOY.js';

const FilterRadioGroup = ({
  radioGroupName = '',
  radioGroupLabel = '',
  ...restProps
}) => /*#__PURE__*/React.createElement(FilterDropdown, _extends({
  hideLabel: true // copied from ./FilterRadioGroupBody.tsx
}, restProps, {
  mobileFullScreen: true,
  name: radioGroupName,
  label: radioGroupLabel
}));

export { FilterRadioGroup as F };
//# sourceMappingURL=FilterRadioGroup-DmE4gGnW.js.map
